/**
 * DislikesStep.validation.js
 *
 * Pure function, no React — mirrors LikesStep.validation.js. Dislikes is
 * entirely optional per the FSD, so isValid is only ever false in the
 * defensive case where something manages to push more than MAX_DISLIKES
 * entries into formData.dislikes (the UI itself prevents this by
 * disabling further selection once the cap is hit — see DislikesStep.js).
 */

import { MAX_DISLIKES } from "./DislikesStep.constants";

export function validateDislikes(data) {
  const errors = {};

  if (!Array.isArray(data.dislikes)) {
    errors.dislikes = "Dislikes must be a list.";
  } else if (data.dislikes.length > MAX_DISLIKES) {
    errors.dislikes = `Please select at most ${MAX_DISLIKES} foods.`;
  }

  return { isValid: Object.keys(errors).length === 0, errors };
}
